export default "__VITE_ASSET__B$_7qDud__"